"use strict";
/**
 * UK National Curriculum primary subjects (statutory set).
 *
 * RSHE (Relationships, Sex & Health Education) is folded under `pshe` per
 * 2020 statutory guidance — delivered through PSHE but tracked via themes.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBJECT_ORDER = void 0;
exports.getSubjectLabel = getSubjectLabel;
exports.SUBJECT_ORDER = [
    'english',
    'maths',
    'science',
    'history',
    'geography',
    'computing',
    're',
    'pshe',
    'art_design',
    'design_technology',
    'music',
    'pe',
    'mfl',
];
const SUBJECT_LABELS = {
    english: 'English',
    maths: 'Maths',
    science: 'Science',
    history: 'History',
    geography: 'Geography',
    computing: 'Computing',
    art_design: 'Art & Design',
    design_technology: 'Design & Technology',
    music: 'Music',
    pe: 'PE',
    mfl: 'Languages',
    re: 'Religious Education',
    pshe: 'PSHE',
};
function getSubjectLabel(subject) {
    return SUBJECT_LABELS[subject];
}
